import { Nullable } from 'clickNgo/models/utils'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { IColumn } from 'core-components/library/list/types'
import { Tooltip } from 'core-components/library/tooltip'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'
import { IQBRPartner } from 'partner360/models/qbr/IQBRPartners'
import { CircularProgress } from 'shared/components/circularProgress'

import styles from '../SettingsStep.module.scss'

interface IGetColumns {
  setItemToDelete: (version: IQBRPartner) => void
  onOpenPartnerPlan: (version: IQBRPartner) => void
  isFinalized?: boolean
  globalPartnerId: Nullable<string>
}

export const getColumns = ({
  setItemToDelete,
  onOpenPartnerPlan,
  isFinalized,
  globalPartnerId,
}: IGetColumns): IColumn<IQBRPartner>[] => {
  const baseColumns = [
    {
      field: 'PartnerID',
      title: TRANSLATION_KEYS.addPartnersModal.table.partnerId,
      hideSettings: true,
      priority: 1,
    },
    {
      field: 'CommunicationName',
      title: TRANSLATION_KEYS.addPartnersModal.table.communicationName,
      hideSettings: true,
      priority: 2,
    },
    {
      field: 'LocationID',
      title: TRANSLATION_KEYS.addPartnersModal.table.locationId,
      hideSettings: true,
      priority: 3,
    },
    {
      field: 'GeoRegion',
      title: TRANSLATION_KEYS.addPartnersModal.table.geoRegion,
      hideSettings: true,
      priority: 4,
    },
    {
      field: 'GeoMarket',
      title: TRANSLATION_KEYS.addPartnersModal.table.geoMarket,
      hideSettings: true,
      priority: 5,
    },
    {
      field: 'Country',
      title: TRANSLATION_KEYS.addPartnersModal.table.country,
      hideSettings: true,
      priority: 6,
    },
    {
      field: 'HierarchyType',
      title: TRANSLATION_KEYS.addPartnersModal.table.hierarchyType,
      hideSettings: true,
      priority: 7,
      withoutOperator: true,
    },

    {
      field: 'P360Plan',
      title: TRANSLATION_KEYS.addPartnersModal.table.plan,
      hideSettings: true,
      priority: 8,
      renderFunction: (item: IQBRPartner) => {
        return (
          <CircularProgress
            percent={item.Plan360Completeness}
            radius={20}
            isShowCompletedIcon={Boolean(item.IsAcknowledged)}
          />
        )
      },
    },

    {
      field: 'PBM',
      title: TRANSLATION_KEYS.addPartnersModal.table.pbm,
      hideSettings: true,
      priority: 9,
    },
    {
      field: 'Manager',
      title: TRANSLATION_KEYS.addPartnersModal.table.manager,
      hideSettings: true,
      priority: 10,
    },
  ]

  if (isFinalized || globalPartnerId) {
    return baseColumns
  }

  return [
    ...baseColumns,
    {
      field: 'Btns',
      title: '',
      hideSettings: true,
      renderFunction: (item) => {
        return (
          <div>
            <Tooltip
              className={styles.tooltip}
              tipContent={() => (
                <Translation text={TRANSLATION_KEYS.buttons.openPartnerPlanTooltip} />
              )}
            >
              <Button
                icon={'kbase kbase-article'}
                variant={'text'}
                onClick={() => onOpenPartnerPlan(item)}
              />
            </Tooltip>
            <Tooltip
              className={styles.tooltip}
              tipContent={() => (
                <Translation text={TRANSLATION_KEYS.buttons.deletePartnerTooltip} />
              )}
            >
              <Button
                icon={'kbase kbase-delete'}
                variant={'text'}
                onClick={() => setItemToDelete(item)}
              />
            </Tooltip>
          </div>
        )
      },
      priority: 11,
    },
  ]
}
